
import { defineComponent, onMounted, ref } from "vue";
import store from "@/store/index";
import Utils from "@/components/Utils";
import CampaignTerms from "@/components/CampaignTerms.vue";

export default defineComponent({
  components: {
    CampaignTerms,
  },

  computed: {
    selectCampaign() {
      return store.state.selectCampaign;
    },
    selectPostCampaign() {
      return store.state.selectPostCampaign;
    },
    showPostedCampaign() {
      return store.state.showPostedCampaign;
    },
  },

  watch: {
    async selectCampaign(value) {
      if (!value) {
        store.commit("setReadyNotice", true);
        return;
      }
      this.disablePlayerControl();
      this.campaign = value;
      this.countTotal();

      if (value.id === "new_register_2023") {
        this.showApplyWindow = true;
        this.isPostSuccess = false;
      } else {
        this.showApplyWindow = false;
        this.applyCheck = false;
        this.applyMessage = "";
        this.campaignSelectItem =
          value.select === undefined ? -1 : value.select;
        this.showWindow = true;
      }
    },
    async selectPostCampaign(value) {
      if (!value) return;
      this.disablePlayerControl();
      this.campaign = value;
      this.showApplyWindow = true;
      this.isPostSuccess = false;
      this.countTotal();
    },
    showPostedCampaign(value) {
      if (!value) return;
      this.postSuccess();
    },
  },

  setup() {
    const campaignSelectItem = ref<number>(-1);
    const campaign = ref<Campaign>();
    const showWindow = ref<boolean>(false);
    const showApplyWindow = ref<boolean>(false);
    const showPostWindow = ref<boolean>(false);
    const applyMessage = ref<string>("");
    const isPostSuccess = ref<boolean>(false);
    const applyCheck = ref<boolean>(false);
    const total = ref<number>(0);

    const getCampaign = (): Campaign | undefined => {
      return store.state.campaign.find(
        (v: Campaign) =>
          v.id === campaign.value?.id &&
          v.startDateTime === campaign.value?.startDateTime &&
          v.endDateTime === campaign.value?.endDateTime
      );
    };

    const select = (index: number) => {
      campaignSelectItem.value = index;
      const c = getCampaign();
      if (c) c.select = index;
    };

    const disablePlayerControl = () => {
      const unityInstance = store.state.unityInstance;
      unityInstance.SendMessage("[GameManager]", "DisablePlayerController");
    };

    const closeWindow = () => {
      showWindow.value = false;
      showApplyWindow.value = false;
      showPostWindow.value = false;
      store.commit("setSelectCampaign", undefined);
      store.commit("setSelectPostCampaign", undefined);
      const unityInstance = store.state.unityInstance;
      unityInstance.SendMessage("[GameManager]", "ClosePresentWindow");
    };

    const countTotal = () => {
      if (!campaign.value || !campaign.value.list) return;
      let sum = 0;
      for (var item of campaign.value.list) {
        sum += item.quantity;
      }

      total.value = sum;
    };

    const apply = async () => {
      if (!campaign.value) return;

      if (campaign.value.campaignType !== "newMember") {
        if (campaign.value.select === undefined || campaign.value.select < 0) {
          applyMessage.value = "景品を選択してください";
          return;
        }
      }

      if (!applyCheck.value) {
        applyMessage.value = "同意してください";
        return;
      }

      const isLogin = await Utils.isLogin();
      if (!isLogin) {
        location.href = `${Utils.baseUrl}/virtual/login/`;
        return;
      }

      const c = getCampaign();
      if (c) c.apply = true;

      let body = new FormData();
      body.append("id", campaign.value.id);
      if (campaign.value.list) {
        const item = campaign.value.list[campaignSelectItem.value];
        body.append("prize", item.title);
        body.append("choice", item.code);
      }

      const success = await Utils.sendCampaign(body);

      showApplyWindow.value = false;
      applyCheck.value = false;
      applyMessage.value = "";

      if (success) {
        const c = getCampaign();
        if (c) c.isApply = true;
        postSuccess();

        const posts = document.querySelectorAll<HTMLElement>(".post");
        for (const post of posts) {
          post.classList.remove("show");
        }

        const unityInstance = store.state.unityInstance;
        unityInstance.SendMessage("CampaignManager", "Finish", c?.type);
      } else {
        isPostSuccess.value = false;
        showPostWindow.value = true;
      }
    };

    const postSuccess = () => {
      isPostSuccess.value = true;
      showPostWindow.value = true;

      store.commit(
        "setCampaign",
        JSON.parse(JSON.stringify(store.state.campaign))
      );
    };

    onMounted(() => {
      if (store.state.showPostedCampaign) {
        postSuccess();
        store.commit("setShowPostedCampaign", false);
      }
    });

    return {
      campaignSelectItem,
      showWindow,
      showApplyWindow,
      showPostWindow,
      campaign,
      select,
      disablePlayerControl,
      closeWindow,
      apply,
      applyCheck,
      applyMessage,
      isPostSuccess,
      postSuccess,
      total,
      countTotal,
    };
  },
});
